import { createSlice } from "@reduxjs/toolkit";
import { getRoomBookings } from "./_bookingAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const bookingList = createSlice({
  name: "bookingList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getRoomBookings.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getRoomBookings.fulfilled, (state, { payload }) => {
        console.log("object",payload)
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getRoomBookings.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
